<ng-container *ngIf="supportModeService.inSupportMode">
  <span i18n>You are in Support Mode.</span>
  <span i18n>Tracking Status: {{supportModeService.trackingStatus | humanize}}</span>
  <span>
    <button class="ui primary button" (click)="supportModeService.stopTracking()"
      [hidden]="supportModeService.trackingStatus === 'disconnected'" i18n>Stop Tracking</button>
    <button class="ui primary button" (click)="supportModeService.startTracking()"
      [hidden]="supportModeService.trackingStatus !== 'disconnected'" i18n>Start Tracking</button>
  </span>
</ng-container>

<ng-container *ngIf="inDemoMode">
  <span i18n>You are in Demo Mode.</span>
</ng-container>

<ng-container *ngIf="inReadOnlyMode">
  <span i18n>You are in View-Only mode.</span>
</ng-container>


<span class="close-icon" (click)="hideBanner()">
  <i class="close icon"><svg   data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.01 30.01"><path d="M16.38 15.01L29.73 1.66A1 1 0 0 0 28.36.29L15.01 13.64 1.66.29A1 1 0 0 0 .29 1.66l13.35 13.35L.29 28.36a1 1 0 0 0 1.37 1.37l13.35-13.35 13.35 13.35a1 1 0 0 0 1.37-1.37z" fill="#757575" fill-rule="evenodd"/></svg></i>
</span>